import { render, staticRenderFns } from "./RequerimientoSeleccionado.vue?vue&type=template&id=c99b1a30&scoped=true"
import script from "./RequerimientoSeleccionado.vue?vue&type=script&lang=js"
export * from "./RequerimientoSeleccionado.vue?vue&type=script&lang=js"
import style0 from "./RequerimientoSeleccionado.vue?vue&type=style&index=0&id=c99b1a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b1a30",
  null
  
)

export default component.exports